var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "usermanagement" },
    [
      _c("md-dialog-alert", {
        ref: "alert",
        attrs: { "md-content": _vm.alert.content, "md-ok-text": _vm.alert.ok },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "users-main" },
        [
          _c(
            "div",
            { staticClass: "datatable-wrapper" },
            [
              _c(
                "wb-data-table",
                _vm._b(
                  {
                    on: {
                      addEmit: _vm.addNewUser,
                      editEmit: _vm.editEmit,
                      changeEmit: _vm.watchUserInput,
                      deleteEmit: _vm.removeEmit,
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm._l(_vm.tableColumns, function (column) {
                          return {
                            key: column.slotName,
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                column.slotName
                                  ? _vm._t(column.slotName, null, { row: row })
                                  : _vm._e(),
                              ]
                            },
                          }
                        }),
                      ],
                      null,
                      true
                    ),
                  },
                  "wb-data-table",
                  _vm.userDataTableProperties,
                  false
                )
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.addUserAllowed ||
                    (!_vm.newUser.hasConsoleAccess &&
                      _vm.newUser.hasProgrammaticAccess),
                  expression:
                    "addUserAllowed || (!newUser.hasConsoleAccess && newUser.hasProgrammaticAccess)",
                },
              ],
              staticClass: "userTableButton",
              attrs: {
                disabled:
                  !_vm.addUserAllowed &&
                  !(
                    !_vm.newUser.hasConsoleAccess &&
                    _vm.newUser.hasProgrammaticAccess
                  ),
              },
              on: { click: _vm.addUser },
            },
            [_vm._t("addButton")],
            2
          ),
          _vm._v(" "),
          _c("p", { staticClass: "error-msg" }, [
            _vm._v(_vm._s(_vm.validationErrorMsg)),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          ref: "edit-user",
          staticClass: "usermanagement-dialog sidebar-dialog",
        },
        [
          _c(
            "md-dialog-title",
            [
              _c("div", [_vm._t("changeRole")], 2),
              _vm._v(" "),
              _c(
                "md-icon",
                {
                  nativeOn: {
                    click: function ($event) {
                      return _vm.closeDialog("edit-user")
                    },
                  },
                },
                [_vm._v("clear")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("md-dialog-content", [
            _c("div", { staticClass: "sidebar-content" }, [
              _vm.programmaticAccess
                ? _c(
                    "div",
                    { staticClass: "custom-input-block" },
                    [
                      _c(
                        "md-input-container",
                        [
                          _c(
                            "label",
                            { attrs: { for: "name" } },
                            [_vm._t("nameLabel")],
                            2
                          ),
                          _vm._v(" "),
                          _c("md-input", {
                            attrs: { name: "name", id: "name" },
                            model: {
                              value: _vm.entity.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.entity, "name", $$v)
                              },
                              expression: "entity.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom-input-block" },
                [
                  _c(
                    "md-input-container",
                    [
                      _c(
                        "label",
                        { attrs: { for: "role" } },
                        [_vm._t("roleLabel")],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "md-select",
                        {
                          attrs: { name: "role", id: "role" },
                          model: {
                            value: _vm.entity.role,
                            callback: function ($$v) {
                              _vm.$set(_vm.entity, "role", $$v)
                            },
                            expression: "entity.role",
                          },
                        },
                        _vm._l(_vm.getRoles, function (role) {
                          return _c(
                            "md-option",
                            { key: role.id, attrs: { value: role.id } },
                            [_vm._v(_vm._s(role.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.programmaticAccess
                ? _c(
                    "div",
                    { staticClass: "custom-input-block" },
                    [
                      _c(
                        "md-input-container",
                        [
                          _c(
                            "label",
                            { attrs: { for: "description" } },
                            [_vm._t("descLabel")],
                            2
                          ),
                          _vm._v(" "),
                          _c("md-input", {
                            attrs: { name: "description", id: "description" },
                            model: {
                              value: _vm.entity.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.entity, "description", $$v)
                              },
                              expression: "entity.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btns-container" },
                [
                  _c(
                    "md-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog("edit-user")
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    {
                      staticClass: "primary",
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-dialog",
        { ref: "remove-user", staticClass: "usermanagement-dialog" },
        [
          _c("md-dialog-title", [
            _vm._v(
              "\n            Are you sure you would like to remove this user?\n        "
            ),
          ]),
          _vm._v(" "),
          _c("md-dialog-content"),
          _vm._v(" "),
          _c(
            "md-dialog-actions",
            [
              _c(
                "md-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.closeDialog("remove-user")
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.deleteUser()
                    },
                  },
                },
                [_vm._v("Ok")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }